<template>
  <div class="ticket" :class="ticket && getStatus ? `ticket-status-${getStatus}` : ''">
    <div class="ticket-first-line">
      <new-messenger-conversation-header :ticket="ticket" :target="'tickets'" />
    </div>
    <div class="ticket-second-line">
      <div>
        <span class="ticket-messages-unread-indicator" />
        <span class="ticket-second-line-title">
          <template v-if="ticket.lastMessage">
            {{ ticket.lastMessage.isMine ? 'Ty:' : '' }} {{ ticket.lastMessage.message }}
          </template>
        </span>
      </div>
      <span class="ticket-time">
        {{ getTime }}
      </span>
    </div>
  </div>
</template>

<script>
import NewMessengerConversationHeader from './NewMessengerConversationHeader'

export default {
  name: 'NewMessengerTicket',
  components: { NewMessengerConversationHeader },
  props: {
    ticket: {
      type: Object,
      default: null
    }
  },
  computed: {
    getTime () {
      return this.ticket.lastMessage?.date ? this.$moment(this.ticket.lastMessage.date.date).format('ddd HH:mm') : ''
    },
    getStatus () {
      return this.ticket.unreadMessages ? 'unread' : this.ticket.id === parseInt(this.$route.query.ticketId) ? 'reading' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
$ticket-hover-bg-color: #f8f8f8;
$ticket-status-reading-hover-bg-color: #F2F2F2;
$ticket-status-unread-bg-color: rgba($primary, 0.05);
$ticket-status-unread-hover-bg-color: rgba($primary, 0.09);

.ticket {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;

  &:hover {
    cursor: pointer;
    background-color: $ticket-hover-bg-color;
  }

  &.ticket-status-reading {
    background-color: $ticket-hover-bg-color;

    &:hover {
      background-color: $ticket-status-reading-hover-bg-color;
    }
  }

  &.ticket-status-unread {
    background-color: $ticket-status-unread-bg-color;

    &:hover {
      background-color: $ticket-status-unread-hover-bg-color;
    }

    .ticket-messages-unread-indicator {
      display: block !important;
    }

    :deep(.ticket-title),
    :deep(.initials),
    .ticket-second-line-title,
    .ticket-time {
      font-weight: 600 !important;
    }

    :deep(.circle) {
      border-color: rgba($primary, 0.06) !important;
    }
  }

  .ticket-first-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    .ticket-users-title-container {
      display: flex;
      align-items: center;
      gap: 10px;
      overflow: hidden;

      .ticket-users {
        display: flex;

        &> :deep(.avatar-container) {
          &:nth-child(1) {
            z-index: 10;
          }

          &:nth-child(2) {
            margin-left: -19px;
            opacity: 0.8;
          }
        }
      }

      .ticket-title {
        flex-shrink: 1;
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .ticket-language {
      flex-shrink: 0;
      width: 18px;
      height: 18px;

      .flag-circle {
        width: 18px;
        height: 18px;
        position: relative;
        overflow: hidden;
        border-radius: 50%;

        img {
          display: inline;
          width: auto;
          height: 100%;
        }
      }
    }
  }

  .ticket-second-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-width: 0;
    font-size: 12px;

    &>div {
      display: flex;
      align-items: center;
      gap: 6px;
      min-width: 0;

      .ticket-messages-unread-indicator {
        display: none;
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background-color: $primary;
      }

      .ticket-second-line-title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .ticket-time {
      flex-shrink: 0;
    }
  }
}
</style>
